import { ShippingOption } from './shippingOption';
import { Base64 } from './../../lib/helpers/utils';
import { ShippingType } from './shippingType';

export class Shipping {
    agencia = '';
    almacen = '';
    almacenCodigo = '';
    tiempo = '';
    tiempo2 = '';
    descripcion = '';
    shippingOptions: ShippingOption[] = [];
    shippingOptionSelected: string = null;
    cantidad = 0;
    total = 0;
    colorEntrega = 0;
}

/**
 * Shipping of each item
 *
 * @export
 * @class Shipping
 */
export class ShippingHelper {
    static getShippingOptionSelected(shipping: Shipping) {
        return shipping.shippingOptionSelected;
    }

    static setShippingOptionSelected(shipping: Shipping, value: string) {
        let find = false;
        for (const option of shipping.shippingOptions) {
            if (value === option.id) {
                find = true;
            }
        }
        shipping.shippingOptionSelected = find ? value : null;
    }

    static getType(shipping: Shipping): ShippingType {
        if (shipping.tiempo.toLowerCase() === 'mañana') {
            return ShippingType.OneDay;
        }
        if (shipping.tiempo.toLowerCase() === 'today') {
            return ShippingType.Today;
        }
        return ShippingType.Date;
    }

    static getHash(shipping: Shipping) {
        return Base64.encode(shipping.almacenCodigo + shipping.tiempo + shipping.descripcion);
    }
}
